import { Database, DatabaseAdapter } from '@nozbe/watermelondb'
import { Chat, Message } from '../model'
import { ChatRepository, MessageRepository } from '../repositories'
import { deleteChats, deleteMessages } from '../writers'

export class DBInstance {
  public database: Database
  public chatRepository: ChatRepository
  public messageRepository: MessageRepository

  constructor(adapter: DatabaseAdapter) {
    const database = new Database({
      adapter,
      modelClasses: [Chat, Message]
    })
    this.database = database
    this.chatRepository = new ChatRepository(database)
    this.messageRepository = new MessageRepository(database)
  }

  deleteAllData = async () => {
    await Promise.all([deleteChats(this.database), deleteMessages(this.database)])
    console.info('Database data deleted')
  }

  resetDatabase = async () => {
    await this.database.write(async () => {
      await this.database.unsafeResetDatabase()
    })
    console.info('Database reseted')
  }
}
